import React from 'react';
import { Link } from 'react-router-dom';
import { 
  FaFacebookF, 
  FaTwitter, 
  FaInstagram, 
  FaLinkedinIn, 
  FaPinterestP,
  FaPhone,
  FaEnvelope,
  FaMapMarkerAlt
} from 'react-icons/fa';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Company Info */}
        <div className="footer-section">
          <div className="footer-logo">
            <div className="footer-logo-image">
              <span className="footer-logo-text">F&H</span>
            </div>
            <h3>F&H Audio Solutions LLP</h3>
          </div>
          <p className="footer-description">
            Crafting bespoke luxury Audio-Visual home entertainment systems and Home Automation 
            experiences for discerning homes. Elevate your living with unparalleled sophistication.
          </p>
          <div className="social-links">
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
              <FaFacebookF />
            </a>
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
              <FaTwitter />
            </a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <FaInstagram />
            </a>
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
              <FaLinkedinIn />
            </a>
            <a href="https://pinterest.com" target="_blank" rel="noopener noreferrer" aria-label="Pinterest">
              <FaPinterestP />
            </a>
          </div>
        </div>

        {/* Quick Links */}
        <div className="footer-section">
          <h4>Quick Links</h4>
          <ul className="footer-links">
            <li><Link to="/">Home</Link></li>
            <li><Link to="/about">About</Link></li>
            <li><Link to="/services/pa-system">Our Expertise</Link></li>
            <li><Link to="/products">Collections</Link></li>
            <li><Link to="/consultancy">Consultancy</Link></li>
            <li><Link to="/new-arrivals">New Arrivals</Link></li>
          </ul>
        </div>

        {/* Services */}
        <div className="footer-section">
          <h4>Our Services</h4>
          <ul className="footer-links">
            <li><Link to="/services/pa-system">PA System Design & Installation</Link></li>
            <li><Link to="/services/acoustic-solutions">Acoustic Solutions</Link></li>
            <li><Link to="/services/training-service">Training & Service</Link></li>
            <li><Link to="/system-planner">AI-Powered System Planner</Link></li>
            <li><Link to="/consultancy">Consultation</Link></li>
            <li><Link to="/contact">Get in Touch</Link></li>
          </ul>
        </div>

        {/* Contact Info */}
        <div className="footer-section">
          <h4>Contact Us</h4>
          <div className="contact-info">
            <div className="contact-item">
              <FaPhone />
              <a href="tel:+919876543210">+91 98765 43210</a>
            </div>
            <div className="contact-item">
              <FaEnvelope />
              <a href="mailto:info@fhaudio.in">info@fhaudio.in</a>
            </div>
            <div className="contact-item">
              <FaMapMarkerAlt />
              <p>#22-11-120, first floor, thunuguntlavari street,<br />chendanabrothers side line, Lalapet,<br />Guntur, Andhra Pradesh 522003</p>
            </div>
          </div>
          <div className="appointment-note">
            <p><strong>Note:</strong> Visitation by appointment only. Please schedule in advance.</p>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="footer-bottom">
        <div className="footer-bottom-container">
          <p>&copy; {currentYear} F&H Audio Solutions LLP - All rights reserved.</p>
           <Link to="/privacy">Privacy Policy</Link>
            <span className="separator">|</span>
            <Link to="/terms">Terms & Conditions</Link>
          <div className="footer-bottom-links">

             <Link to="/#">Site Developed & Maintained By : PIVOT SOFTWARE & CONSULTANCY LLP,  GUNTUR</Link>
            <span className="separator"></span>
           
          </div>
        </div>
      </div>
      
      {/* Diagonal Watermark */}
      <div className="footer-watermark">
        <span>F & H Audio Solutions </span>
      </div>
    </footer>
  );
};

export default Footer;
